<template>
    <div class="b_breadcrumbs" :class="{ hide_on_mobile: hideOnMobile }">
        <div class="breadcrumbs">
            <ul>
                <li
                    v-for="(breadcrumb, index) of items"
                    :key="`breadcrumb-${index}`"
                >
                    <nuxt-link
                        v-if="breadcrumb.to"
                        :to="localePath(breadcrumb.to)"
                    >
                        {{ breadcrumb.text }}
                    </nuxt-link>

                    <template v-else>
                        {{ breadcrumb.text }}
                    </template>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import getBreadcrumbList from '@/helpers/schemaOrg/getBreadcrumbList';

export default {
    props: {
        items: {
            type: Array,
            required: true
        },

        hideOnMobile: {
            type: Boolean,
            default: false
        },

        hideJsonldBreadcrumbs: {
            type: Boolean,
            default: false
        }
    },

    jsonld() {
        if (this.hideJsonldBreadcrumbs) {
            return null;
        }

        return getBreadcrumbList({
            breadcrumbs: this.items
        });
    }
};
</script>
